import { useState, useEffect } from "react";
import { latestEvents } from "../services";

export const useLatestEvents = (sportUuid?: string) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [eventsLatest, setEventsLatest] =
    useState<Awaited<ReturnType<typeof latestEvents>>["data"]>();

  useEffect(() => {
    if (!sportUuid) return;

    latestEvents(sportUuid)
      .then(({ data }) => {
        setEventsLatest(data);
        setIsLoaded(true);
      })
      .catch(console.error);
  }, [sportUuid]);

  return { isLoaded, eventsLatest };
};
